<h2 mat-dialog-title>Filtros</h2>
<mat-dialog-content>
  <p>Aseguradoras</p>
  <mat-chip-listbox [multiple]="false" [selectable]="true" [(ngModel)]="selectedInsurers" [compareWith]="compareInsurer">
    @for (insurer of insurers; track insurer) {
      <mat-chip-option [value]="insurer">
        {{ insurer.description }}
      </mat-chip-option>
    }
  </mat-chip-listbox>
  <br>
  <p>Estados</p>
  <mat-chip-listbox [multiple]="true" [selectable]="true" [(ngModel)]="selectedStatus" [compareWith]="compareStatus">
    @for (status of statusList; track status) {
      <mat-chip-option [value]="status" >
        {{ status[1] }}
      </mat-chip-option>
    }
  </mat-chip-listbox>
  <br>
  <form class="form-horizontal" [formGroup]="form">
    <mat-form-field class="full-width-field">
      <mat-label>ID Asegurado</mat-label>
      <input matInput formControlName="insuredId">
      @if (form.controls['insuredId'].hasError('required')) {
        <mat-error>Requerido</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="full-width-field">
      <mat-label>Placa</mat-label>
      <input matInput formControlName="insurableInterestIdentifier">
      @if (form.controls['insurableInterestIdentifier'].hasError('required')) {
        <mat-error>Requerido</mat-error>
      }
    </mat-form-field>
  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <button mat-button (click)="createClick()">Enviar</button>
</mat-dialog-actions>
